import type { Block } from '@gitbook/slate';

/**
 * Test if a block is empty.
 */
export function isBlockEmpty(block: Block, opts: { trim?: boolean } = {}): boolean {
    const { trim = false } = opts;

    if (block.isVoid) {
        return false;
    }

    if (block.nodes.size === 0) {
        return true;
    }

    const firstNode = block.nodes.first();
    if (firstNode?.object === 'block') {
        return block.nodes.size === 1 && isBlockEmpty(firstNode, opts);
    }

    // support also non normalized block that contains multiple texts not merged
    return block.nodes.every(
        (child) => child.object === 'text' && (trim ? child.text.trim() : child.text) === ''
    );
}
